import { FunctionComponent } from 'react';

import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import UserImage from './UserImage';
import { useAppMessaging } from '../../../hooks/useAppMessaging';
import { BreakoutUser } from '../../../types/breakoutRoomTypes';

interface UnassignedUserListProps {
    userList: BreakoutUser[];
    roomId: string;
    onCloseHandler: () => void;
}

const UnassignedUserList: FunctionComponent<UnassignedUserListProps> = ({ onCloseHandler, roomId, userList }) => {
    const { sendMessage } = useAppMessaging();

    const handleUserSelected = (userId: string) => (event) => {
        event.stopPropagation();

        sendMessage({
            payload: { func: 'assign_breakout_user', user_id: userId, room_id: roomId }
        });

        // if user list is now empty close the popout
        if (userList.length === 0) {
            onCloseHandler();
        }
    };

    return (
        <List sx={{ width: '100%', maxWidth: 350, bgcolor: 'background.paper' }}>
            {userList.map((user) => {
                const labelId = `user-label-${user.name}`;

                return (
                    <ListItem key={user.breakoutUserId} disablePadding>
                        <ListItemButton role={undefined} onClick={handleUserSelected(user.breakoutUserId)} dense>
                            <ListItemIcon>
                                <Checkbox
                                    edge="end"
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <UserImage imgSource={user.imageUrl} name={user.name} />
                            <ListItemText id={labelId} primary={user.name} />
                        </ListItemButton>
                    </ListItem>
                );
            })}
        </List>
    );
};

export default UnassignedUserList;
